export const environment = {
  production: true,
  baseUrl: '/',
  apiUrl: '/api/',
  firebase: {
    apiKey: "AIzaSyDDFAzApsKvTSEqvrpGiD9U2TtRalrz5qc",
    authDomain: "devportfolio-ccca6.firebaseapp.com",
    databaseURL: "https://devportfolio-ccca6.firebaseio.com",
    projectId: "devportfolio-ccca6",
    storageBucket: "devportfolio-ccca6.appspot.com",
    messagingSenderId: "865260696268"
  },
  stripeKey: 'pk_live_i0QcZ4bzihfZbru8NNIgTyAH',
  subscriptionPriceID: 'price_1HZio72E2qJR4V5UPLfjp0GC',
  LogRocketID: 'nlauoh/prod-mydevportfolio'
};


// WEBPACK FOOTER //
// ./src/environments/environment.ts